import { authenticatedFetcher } from '@/lib/swr';
import { PP_BASE_URL } from '@/lib/env';

type UpdateStudentStatusPayload = {
  status?: number | null;
  isInformationUpdated?: boolean;
  informationUpdatedAt?: string;
  isConductAgreementSigned?: boolean;
  conductAgreementSignedAt?: string;
};

export async function updateStudentStatus(studentId: string, payload: UpdateStudentStatusPayload) {
  const baseUrl = PP_BASE_URL?.replace(/\/$/, '');
  if (!baseUrl) {
    throw new Error('PP_BASE_URL is not configured');
  }

  const url = `${baseUrl}/students/${encodeURIComponent(studentId)}/status`;
  return await authenticatedFetcher(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
}
